export default __webpack_public_path__ + "c3cac82836bed2a01ccc4c7012bc460b.png";